var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.197 18.55-.793.793a.853.853 0 0 1-1.21 0l-6.942-6.939a.854.854 0 0 1 0-1.21l6.942-6.942a.853.853 0 0 1 1.21 0l.793.793a.857.857 0 0 1-.014 1.224l-4.303 4.1h10.263c.475 0 .857.382.857.857v1.143a.855.855 0 0 1-.857.857H8.88l4.303 4.1a.85.85 0 0 1 .014 1.224",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;